import { getArrowsPositionOptions, PostListWidgetSliderArrowsPosition, } from './post-list.wix-params';
export var AuthorInfoType;
(function (AuthorInfoType) {
    AuthorInfoType[AuthorInfoType["NameAndPicture"] = 0] = "NameAndPicture";
    AuthorInfoType[AuthorInfoType["Name"] = 1] = "Name";
})(AuthorInfoType || (AuthorInfoType = {}));
export var ContentAlignment;
(function (ContentAlignment) {
    ContentAlignment[ContentAlignment["Left"] = 0] = "Left";
    ContentAlignment[ContentAlignment["Center"] = 1] = "Center";
    ContentAlignment[ContentAlignment["Right"] = 2] = "Right";
})(ContentAlignment || (ContentAlignment = {}));
export const feedWidgetStyleParams = {
    'banner-isEnabled': {
        defaultValue: false,
        key: 'banner-isEnabled',
    },
    'blog-authorInfoType': {
        key: 'blog-authorInfoType',
    },
    'blog-isAnonymousCommentsEnabled': {
        key: 'blog-isAnonymousCommentsEnabled',
    },
    'blog-isAuthorBadgeEnabled': {
        key: 'blog-isAuthorBadgeEnabled',
    },
    'blog-isAuthorNameEnabled': {
        key: 'blog-isAuthorNameEnabled',
    },
    'blog-isAuthorPictureEnabled': {
        key: 'blog-isAuthorPictureEnabled',
    },
    'blog-isCategoryLabelEnabled': {
        key: 'blog-isCategoryLabelEnabled',
    },
    'blog-isCategoryLabelsEnabled': {
        key: 'blog-isCategoryLabelsEnabled',
    },
    'blog-isCommentCountEnabled': {
        key: 'blog-isCommentCountEnabled',
    },
    'blog-isCommentsEnabled': {
        key: 'blog-isCommentsEnabled',
    },
    'blog-isCoverImageEnabled': {
        key: 'blog-isCoverImageEnabled',
    },
    'blog-isLikeCountEnabled': {
        key: 'blog-isLikeCountEnabled',
    },
    'blog-isMoreOptionsMenuEnabled': {
        key: 'blog-isMoreOptionsMenuEnabled',
    },
    'blog-isPostDateEnabled': {
        key: 'blog-isPostDateEnabled',
    },
    'blog-isPostDescriptionEnabled': {
        key: 'blog-isPostDescriptionEnabled',
    },
    'blog-isPostListFullWidthEnabled': {
        key: 'blog-isPostListFullWidthEnabled',
    },
    'blog-isPostPublishDateEnabled': {
        key: 'blog-isPostPublishDateEnabled',
    },
    'blog-isPostRatingEnabled': {
        key: 'blog-isPostRatingEnabled',
    },
    'blog-isPostTitleEnabled': {
        key: 'blog-isPostTitleEnabled',
    },
    'blog-isPostUpdatedDateEnabled': {
        key: 'blog-isPostUpdatedDateEnabled',
    },
    'blog-isReadingTimeEnabled': {
        key: 'blog-isReadingTimeEnabled',
    },
    'blog-isRecentPostsEnabled': {
        key: 'blog-isRecentPostsEnabled',
    },
    'blog-isTagsEnabled': {
        key: 'blog-isTagsEnabled',
    },
    'blog-isViewCountEnabled': {
        key: 'blog-isViewCountEnabled',
    },
    'blog-mobile-authorInfoType': {
        key: 'blog-mobile-authorInfoType',
    },
    'blog-mobile-isAuthorBadgeEnabled': {
        key: 'blog-mobile-isAuthorBadgeEnabled',
    },
    'blog-mobile-isAuthorNameEnabled': {
        key: 'blog-mobile-isAuthorNameEnabled',
    },
    'blog-mobile-isAuthorPictureEnabled': {
        key: 'blog-mobile-isAuthorPictureEnabled',
    },
    'blog-mobile-isCategoryLabelEnabled': {
        key: 'blog-mobile-isCategoryLabelEnabled',
    },
    'blog-mobile-isCategoryLabelsEnabled': {
        key: 'blog-mobile-isCategoryLabelsEnabled',
    },
    'blog-mobile-isCommentCountEnabled': {
        key: 'blog-mobile-isCommentCountEnabled',
    },
    'blog-mobile-isCommentsEnabled': {
        key: 'blog-mobile-isCommentsEnabled',
    },
    'blog-mobile-isCoverImageEnabled': {
        key: 'blog-mobile-isCoverImageEnabled',
    },
    'blog-mobile-isLikeCountEnabled': {
        key: 'blog-mobile-isLikeCountEnabled',
    },
    'blog-mobile-isMobileDisplaySettingsEnabled': {
        key: 'blog-mobile-isMobileDisplaySettingsEnabled',
    },
    'blog-mobile-isMoreOptionsMenuEnabled': {
        key: 'blog-mobile-isMoreOptionsMenuEnabled',
    },
    'blog-mobile-isPostDateEnabled': {
        key: 'blog-mobile-isPostDateEnabled',
    },
    'blog-mobile-isPostDescriptionEnabled': {
        key: 'blog-mobile-isPostDescriptionEnabled',
    },
    'blog-mobile-isPostPublishDateEnabled': {
        key: 'blog-mobile-isPostPublishDateEnabled',
    },
    'blog-mobile-isPostRatingEnabled': {
        key: 'blog-mobile-isPostRatingEnabled',
    },
    'blog-mobile-isPostTitleEnabled': {
        key: 'blog-mobile-isPostTitleEnabled',
    },
    'blog-mobile-isPostUpdatedDateEnabled': {
        key: 'blog-mobile-isPostUpdatedDateEnabled',
    },
    'blog-mobile-isReadingTimeEnabled': {
        key: 'blog-mobile-isReadingTimeEnabled',
    },
    'blog-mobile-isRecentPostsEnabled': {
        key: 'blog-mobile-isRecentPostsEnabled',
    },
    'blog-mobile-isTagsEnabled': {
        key: 'blog-mobile-isTagsEnabled',
    },
    'blog-mobile-isViewCountEnabled': {
        key: 'blog-mobile-isViewCountEnabled',
    },
    'blogMenu-isCategoryLabelsEnabled': {
        key: 'blogMenu-isCategoryLabelsEnabled',
    },
    'blogMenu-isEnabled': {
        key: 'blogMenu-isEnabled',
    },
    'blogMenu-isSearchEnabled': {
        key: 'blogMenu-isSearchEnabled',
    },
    'blogMenu-mobile-isCategoryLabelsEnabled': {
        key: 'blogMenu-mobile-isCategoryLabelsEnabled',
    },
    'blogMenu-mobile-isEnabled': {
        key: 'blogMenu-mobile-isEnabled',
    },
    'blogMenu-mobile-isLoginButtonEnabled': {
        key: 'blogMenu-mobile-isLoginButtonEnabled',
    },
    'blogMenu-mobile-isSearchEnabled': {
        key: 'blogMenu-mobile-isSearchEnabled',
    },
    'categoryHeader-isEnabled': {
        key: 'categoryHeader-isEnabled',
    },
    contentAlignment: {
        defaultValue: ContentAlignment.Left,
        key: 'contentAlignment',
    },
    contentAlignmentMobile: {
        defaultValue: ContentAlignment.Left,
        key: 'contentAlignmentMobile',
    },
    feedBackgroundColor: {
        defaultOpacity: 0,
        defaultValue: 'color-5',
        key: 'feedBackgroundColor',
    },
    feedSliderArrowsColor: {
        defaultValue: 'color-5',
        key: 'feedSliderArrowsColor',
    },
    feedSliderArrowsPosition: {
        defaultValue: PostListWidgetSliderArrowsPosition.OnGallery,
        key: 'feedSliderArrowsPosition',
        options: getArrowsPositionOptions,
    },
    feedSliderArrowsSize: {
        defaultValue: 18,
        key: 'feedSliderArrowsSize',
        maxValue: 180,
        minValue: 6,
    },
    feedSliderAutoSlide: {
        defaultValue: false,
        key: 'feedSliderAutoSlide',
    },
    feedSliderLoop: {
        defaultValue: false,
        key: 'feedSliderLoop',
    },
    feedSliderPauseTime: {
        defaultValue: 4,
        key: 'feedSliderPauseTime',
        maxValue: 10,
        minValue: 1,
    },
    feedSliderShowArrows: {
        defaultValue: true,
        key: 'feedSliderShowArrows',
    },
    'navigation-backgroundColor': {
        defaultValue: 'rgba(255,255,255,1)',
        key: 'navigation-backgroundColor',
    },
    'navigation-textColor': {
        key: 'navigation-textColor',
    },
    'navigation-textColorActive': {
        key: 'navigation-textColorActive',
    },
    'pinterest-isEnabled': {
        key: 'pinterest-isEnabled',
    },
    'socialSharing-isEnabled': {
        key: 'socialSharing-isEnabled',
    },
    'socialSharing-mobile-isEnabled': {
        key: 'socialSharing-mobile-isEnabled',
    },
    'twitter-isEnabled': {
        key: 'twitter-isEnabled',
    },
    'widget-isLoginButtonEnabled': {
        key: 'widget-isLoginButtonEnabled',
    },
};
// Feed metadata display settings
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_VIEW_COUNT_ENABLED = 'blog-isViewCountEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_VIEW_COUNT_ENABLED_PATH = `style.booleans.${IS_VIEW_COUNT_ENABLED}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_COMMENT_COUNT_ENABLED = 'blog-isCommentCountEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_COMMENT_COUNT_ENABLED_PATH = `style.booleans.${IS_COMMENT_COUNT_ENABLED}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_LIKE_COUNT_ENABLED = 'blog-isLikeCountEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_LIKE_COUNT_ENABLED_PATH = `style.booleans.${IS_LIKE_COUNT_ENABLED}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_AUTHOR_NAME_ENABLED = 'blog-isAuthorNameEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_AUTHOR_NAME_ENABLED_PATH = `style.booleans.${IS_AUTHOR_NAME_ENABLED}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_AUTHOR_PICTURE_ENABLED = 'blog-isAuthorPictureEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_AUTHOR_PICTURE_ENABLED_PATH = `style.booleans.${IS_AUTHOR_PICTURE_ENABLED}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_AUTHOR_BADGE_ENABLED = 'blog-isAuthorBadgeEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_AUTHOR_BADGE_ENABLED_PATH = `style.booleans.${IS_AUTHOR_BADGE_ENABLED}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const AUTHOR_INFO_TYPE = 'blog-authorInfoType';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const AUTHOR_INFO_TYPE_PATH = `style.numbers.${AUTHOR_INFO_TYPE}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const AUTHOR_INFO_TYPE_NAME_PICTURE = 0;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const AUTHOR_INFO_TYPE_NAME = 1;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_POST_DATE_ENABLED = 'blog-isPostDateEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_POST_DATE_ENABLED_PATH = `style.booleans.${IS_POST_DATE_ENABLED}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_POST_UPDATED_DATE_ENABLED = 'blog-isPostUpdatedDateEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_POST_UPDATED_DATE_ENABLED_PATH = `style.booleans.${IS_POST_UPDATED_DATE_ENABLED}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_RECENT_POSTS_ENABLED = 'blog-isRecentPostsEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_RECENT_POSTS_ENABLED_PATH = `style.booleans.${IS_RECENT_POSTS_ENABLED}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_COMMENTS_ENABLED = 'blog-isCommentsEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_COMMENTS_ENABLED_PATH = `style.booleans.${IS_COMMENTS_ENABLED}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_ANONYMOUS_COMMENTS_ENABLED = 'blog-isAnonymousCommentsEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_ANONYMOUS_COMMENTS_ENABLED_PATH = `style.booleans.${IS_ANONYMOUS_COMMENTS_ENABLED}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_CATEGORY_LABELS_ENABLED = 'blog-isCategoryLabelsEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_CATEGORY_LABELS_ENABLED_PATH = `style.booleans.${IS_CATEGORY_LABELS_ENABLED}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_TAGS_ENABLED = 'blog-isTagsEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_TAGS_ENABLED_PATH = `style.booleans.${IS_TAGS_ENABLED}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_TAGS_ENABLED_MOBILE = 'blog-mobile-isTagsEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_TAGS_ENABLED_MOBILE_PATH = `style.booleans.${IS_TAGS_ENABLED_MOBILE}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_POST_TITLE_ENABLED = 'blog-isPostTitleEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_POST_TITLE_ENABLED_PATH = `style.booleans.${IS_POST_TITLE_ENABLED}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_POST_PUBLISH_DATE_ENABLED = 'blog-isPostPublishDateEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_POST_PUBLISH_DATE_ENABLED_PATH = `style.booleans.${IS_POST_PUBLISH_DATE_ENABLED}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_READING_TIME_ENABLED = 'blog-isReadingTimeEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_READING_TIME_ENABLED_PATH = `style.booleans.${IS_READING_TIME_ENABLED}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_MORE_OPTIONS_MENU_ENABLED = 'blog-isMoreOptionsMenuEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_MORE_OPTIONS_MENU_ENABLED_PATH = `style.booleans.${IS_MORE_OPTIONS_MENU_ENABLED}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_POST_DESCRIPTION_ENABLED = 'blog-isPostDescriptionEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_POST_DESCRIPTION_ENABLED_PATH = `style.booleans.${IS_POST_DESCRIPTION_ENABLED}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_COVER_IMAGE_ENABLED = 'blog-isCoverImageEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_COVER_IMAGE_ENABLED_PATH = `style.booleans.${IS_COVER_IMAGE_ENABLED}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_CATEGORY_LABEL_ENABLED = 'blog-isCategoryLabelEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_CATEGORY_LABEL_ENABLED_PATH = `style.booleans.${IS_CATEGORY_LABEL_ENABLED}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_CATEGORY_LABEL_ENABLED_MOBILE = 'blog-mobile-isCategoryLabelEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_CATEGORY_LABEL_ENABLED_MOBILE_PATH = `style.booleans.${IS_CATEGORY_LABEL_ENABLED_MOBILE}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_POST_RATING_ENABLED = 'blog-isPostRatingEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_POST_RATING_ENABLED_PATH = `style.booleans.${IS_POST_RATING_ENABLED}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_POST_RATING_ENABLED_MOBILE = 'blog-mobile-isPostRatingEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_POST_RATING_ENABLED_MOBILE_PATH = `style.booleans.${IS_POST_RATING_ENABLED_MOBILE}`;
// Full width
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_POST_LIST_FULL_WIDTH_ENABLED = 'blog-isPostListFullWidthEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_POST_LIST_FULL_WIDTH_ENABLED_PATH = `style.booleans.${IS_POST_LIST_FULL_WIDTH_ENABLED}`;
// Mobile
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_MOBILE_DISPLAY_SETTINGS_ENABLED = 'blog-mobile-isMobileDisplaySettingsEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_MOBILE_DISPLAY_SETTINGS_ENABLED_PATH = `style.booleans.${IS_MOBILE_DISPLAY_SETTINGS_ENABLED}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_VIEW_COUNT_ENABLED_MOBILE = 'blog-mobile-isViewCountEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_VIEW_COUNT_ENABLED_MOBILE_PATH = `style.booleans.${IS_VIEW_COUNT_ENABLED_MOBILE}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_MORE_OPTIONS_MENU_ENABLED_MOBILE = 'blog-mobile-isMoreOptionsMenuEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_MORE_OPTIONS_MENU_ENABLED_MOBILE_PATH = `style.booleans.${IS_MORE_OPTIONS_MENU_ENABLED_MOBILE}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_COMMENT_COUNT_ENABLED_MOBILE = 'blog-mobile-isCommentCountEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_COMMENT_COUNT_ENABLED_MOBILE_PATH = `style.booleans.${IS_COMMENT_COUNT_ENABLED_MOBILE}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_LIKE_COUNT_ENABLED_MOBILE = 'blog-mobile-isLikeCountEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_LIKE_COUNT_ENABLED_MOBILE_PATH = `style.booleans.${IS_LIKE_COUNT_ENABLED_MOBILE}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_AUTHOR_NAME_ENABLED_MOBILE = 'blog-mobile-isAuthorNameEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_AUTHOR_NAME_ENABLED_MOBILE_PATH = `style.booleans.${IS_AUTHOR_NAME_ENABLED_MOBILE}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_AUTHOR_PICTURE_ENABLED_MOBILE = 'blog-mobile-isAuthorPictureEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_AUTHOR_PICTURE_ENABLED_MOBILE_PATH = `style.booleans.${IS_AUTHOR_PICTURE_ENABLED_MOBILE}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_AUTHOR_BADGE_ENABLED_MOBILE = 'blog-mobile-isAuthorBadgeEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_AUTHOR_BADGE_ENABLED_MOBILE_PATH = `style.booleans.${IS_AUTHOR_BADGE_ENABLED_MOBILE}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const AUTHOR_INFO_TYPE_MOBILE = 'blog-mobile-authorInfoType';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const AUTHOR_INFO_TYPE_MOBILE_PATH = `style.numbers.${AUTHOR_INFO_TYPE_MOBILE}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_POST_DATE_ENABLED_MOBILE = 'blog-mobile-isPostDateEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_POST_DATE_ENABLED_MOBILE_PATH = `style.booleans.${IS_POST_DATE_ENABLED_MOBILE}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_COVER_IMAGE_ENABLED_MOBILE = 'blog-mobile-isCoverImageEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_COVER_IMAGE_ENABLED_MOBILE_PATH = `style.booleans.${IS_COVER_IMAGE_ENABLED_MOBILE}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_POST_UPDATED_DATE_ENABLED_MOBILE = 'blog-mobile-isPostUpdatedDateEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_POST_UPDATED_DATE_ENABLED_MOBILE_PATH = `style.booleans.${IS_POST_UPDATED_DATE_ENABLED_MOBILE}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_RECENT_POSTS_ENABLED_MOBILE = 'blog-mobile-isRecentPostsEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_RECENT_POSTS_ENABLED_MOBILE_PATH = `style.booleans.${IS_RECENT_POSTS_ENABLED_MOBILE}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_COMMENTS_ENABLED_MOBILE = 'blog-mobile-isCommentsEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_COMMENTS_ENABLED_MOBILE_PATH = `style.booleans.${IS_COMMENTS_ENABLED_MOBILE}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_CATEGORY_LABELS_ENABLED_MOBILE = 'blog-mobile-isCategoryLabelsEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_CATEGORY_LABELS_ENABLED_MOBILE_PATH = `style.booleans.${IS_CATEGORY_LABELS_ENABLED_MOBILE}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_POST_TITLE_ENABLED_MOBILE = 'blog-mobile-isPostTitleEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_POST_TITLE_ENABLED_MOBILE_PATH = `style.booleans.${IS_POST_TITLE_ENABLED_MOBILE}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_POST_PUBLISH_DATE_ENABLED_MOBILE = 'blog-mobile-isPostPublishDateEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_POST_PUBLISH_DATE_ENABLED_MOBILE_PATH = `style.booleans.${IS_POST_PUBLISH_DATE_ENABLED_MOBILE}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_READING_TIME_ENABLED_MOBILE = 'blog-mobile-isReadingTimeEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_READING_TIME_ENABLED_MOBILE_PATH = `style.booleans.${IS_READING_TIME_ENABLED_MOBILE}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_POST_DESCRIPTION_ENABLED_MOBILE = 'blog-mobile-isPostDescriptionEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_POST_DESCRIPTION_ENABLED_MOBILE_PATH = `style.booleans.${IS_POST_DESCRIPTION_ENABLED_MOBILE}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_BLOG_MENU_ENABLED_MOBILE = 'blogMenu-mobile-isEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_BLOG_MENU_ENABLED_MOBILE_PATH = `style.booleans.${IS_BLOG_MENU_ENABLED_MOBILE}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_BLOG_MENU_CATEGORY_LABELS_ENABLED_MOBILE = 'blogMenu-mobile-isCategoryLabelsEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_BLOG_MENU_CATEGORY_LABELS_ENABLED_MOBILE_PATH = `style.booleans.${IS_BLOG_MENU_CATEGORY_LABELS_ENABLED_MOBILE}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_BLOG_MENU_SEARCH_ENABLED_MOBILE = 'blogMenu-mobile-isSearchEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_BLOG_MENU_SEARCH_ENABLED_MOBILE_PATH = `style.booleans.${IS_BLOG_MENU_SEARCH_ENABLED_MOBILE}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_BLOG_MENU_LOGIN_BUTTON_ENABLED_MOBILE = 'blogMenu-mobile-isLoginButtonEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_BLOG_MENU_LOGIN_BUTTON_ENABLED_MOBILE_PATH = `style.booleans.${IS_BLOG_MENU_LOGIN_BUTTON_ENABLED_MOBILE}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_SOCIAL_SHARING_ENABLED_MOBILE = 'socialSharing-mobile-isEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_SOCIAL_SHARING_ENABLED_MOBILE_PATH = `style.booleans.${IS_SOCIAL_SHARING_ENABLED_MOBILE}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_PINTEREST_ENABLED = 'pinterest-isEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_PINTEREST_ENABLED_PATH = `style.booleans.${IS_PINTEREST_ENABLED}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_TWITTER_ENABLED = 'twitter-isEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_TWITTER_ENABLED_PATH = `style.booleans.${IS_TWITTER_ENABLED}`;
// Category header params
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_CATEGORY_HEADER_ENABLED = 'categoryHeader-isEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_CATEGORY_HEADER_ENABLED_PATH = `style.booleans.${IS_CATEGORY_HEADER_ENABLED}`;
// Navigation
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const NAVIGATION_BACKGROUND_COLOR = 'navigation-backgroundColor';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const NAVIGATION_BACKGROUND_COLOR_PATH = `style.colors.${NAVIGATION_BACKGROUND_COLOR}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const DEFAULT_NAVIGATION_BACKGROUND_COLOR = 'rgba(255,255,255,1)';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const NAVIGATION_TEXT_COLOR = 'navigation-textColor';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const NAVIGATION_TEXT_COLOR_PATH = `style.colors.${NAVIGATION_TEXT_COLOR}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const NAVIGATION_TEXT_COLOR_ACTIVE = 'navigation-textColorActive';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const NAVIGATION_TEXT_COLOR_ACTIVE_PATH = `style.colors.${NAVIGATION_TEXT_COLOR_ACTIVE}`;
// Banner params
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_BANNER_ENABLED = 'banner-isEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_BANNER_ENABLED_PATH = `style.booleans.${IS_BANNER_ENABLED}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_BANNER_ENABLED_DEFAULT = false;
// Blog menu
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_BLOG_MENU_ENABLED = 'blogMenu-isEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_BLOG_MENU_ENABLED_PATH = `style.booleans.${IS_BLOG_MENU_ENABLED}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_BLOG_MENU_CATEGORY_LABELS_ENABLED = 'blogMenu-isCategoryLabelsEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_BLOG_MENU_CATEGORY_LABELS_ENABLED_PATH = `style.booleans.${IS_BLOG_MENU_CATEGORY_LABELS_ENABLED}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_BLOG_MENU_SEARCH_ENABLED = 'blogMenu-isSearchEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_BLOG_MENU_SEARCH_ENABLED_PATH = `style.booleans.${IS_BLOG_MENU_SEARCH_ENABLED}`;
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_BLOG_MENU_LOGIN_BUTTON_ENABLED = 'widget-isLoginButtonEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_BLOG_MENU_LOGIN_BUTTON_ENABLED_PATH = `style.booleans.${IS_BLOG_MENU_LOGIN_BUTTON_ENABLED}`;
// Social sharing
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_SOCIAL_SHARING_ENABLED = 'socialSharing-isEnabled';
/** @deprecated To be replaced with {@link feedWidgetStyleParams} */
export const IS_SOCIAL_SHARING_ENABLED_PATH = `style.booleans.${IS_SOCIAL_SHARING_ENABLED}`;
export const getIsSocialSharingProviderEnabledParam = (provider, isMobile = false) => `socialSharing-${isMobile ? 'mobile-' : ''}${provider}`;
export const getIsSocialSharingProviderEnabledParamPath = (provider, isMobile = false) => `style.booleans.${getIsSocialSharingProviderEnabledParam(provider, isMobile)}`;
//# sourceMappingURL=feed-page.wix-params.js.map